var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Pos "+_vm._s(_vm.$t('occupancy'))+" "+_vm._s(_vm.$tc('status', 1)))]),_vm._v(" "),_c('button',{staticClass:"btn-modal-close",on:{"click":function($event){return _vm.closeModalSection()}}},[_vm._v("×")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e34133f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PosBookingContainer/posOccupancyStatus.vue
// module id = null
// module chunks = 